import { isDesktop } from "react-device-detect";
import { useCallback } from "react";
import "../../../css/GlobalStyles.css";
import { VerificationAccountType } from "../../../screens/Subscription/SubscriptionPhoneOnboarding";
import StandardBorderedContainer from "../../Containers/StandardBorderedContainer";
import { Colors } from "../../../utils/colors";
import { useTheme } from "../../../hooks/useTheme";
import { Icon } from "@iconify/react";
import RectangleButton from "../../Buttons/RectangleButton";
import TextHoverButton from "../../Buttons/TextHoverButton";
import { MARKIT_DOCS } from "@markit/common.utils";

type PhoneOnboardingSelectTypeProps = {
  selectedAccountType: VerificationAccountType;
  setSelectedAccountType: (accountType: VerificationAccountType) => void;
  selectAccountTypeOnPress: () => void;
};

const PhoneOnboardingSelectType = (props: PhoneOnboardingSelectTypeProps) => {
  const {
    selectedAccountType,
    setSelectedAccountType,
    selectAccountTypeOnPress,
  } = props;
  const { theme } = useTheme();

  const renderSectionItem = useCallback(
    (itemType: VerificationAccountType) => (
      <StandardBorderedContainer
        containerStyles={{
          height: 63,
          display: "flex",
          alignItems: "center",
          borderRadius: 14,
          border: `${
            selectedAccountType === itemType
              ? `2px solid ${Colors.BLACK}`
              : `1.5px solid ${theme.DividerColor.borderColor}`
          }`,
          cursor: "pointer",
        }}
        onPress={() => setSelectedAccountType(itemType)}
      >
        <div
          className="AlignedRowSpaced"
          style={{ paddingInline: 14, width: "100%" }}
        >
          <div className="ColumnNormal" style={{ gap: 4 }}>
            <span className="bodyMedium">
              {itemType === VerificationAccountType.BUSINESS
                ? "Business/Organization"
                : "Individual"}
            </span>
            <span className="smallBodySubtext">
              {itemType === VerificationAccountType.BUSINESS
                ? "For incorporated businesses with EIN number"
                : "If you don't have a business, individual is for you"}
            </span>
          </div>
          {selectedAccountType === itemType ? (
            <Icon
              icon={"ion:checkmark-circle"}
              height={25}
              style={{ color: Colors.BLACK }}
            />
          ) : null}
        </div>
      </StandardBorderedContainer>
    ),
    [
      selectedAccountType,
      setSelectedAccountType,
      theme.DividerColor.borderColor,
    ]
  );

  return (
    <div
      className="ColumnNormal"
      style={{ width: isDesktop ? 340 : undefined, gap: 24 }}
    >
      <div className="ColumnNormal" style={{ gap: 14 }}>
        {renderSectionItem(VerificationAccountType.BUSINESS)}
        {renderSectionItem(VerificationAccountType.INDIVIDUAL)}
      </div>
      <RectangleButton
        buttonLabel={`Continue as ${
          selectedAccountType === VerificationAccountType.BUSINESS
            ? "Business/Organization"
            : "Individual"
        }`}
        containerStyles={{ paddingInline: 10, paddingBlock: 14 }}
        altTextColor={Colors.WHITE}
        altColor={Colors.BLACK}
        onPress={selectAccountTypeOnPress}
      />
      <div style={{ alignSelf: "center" }}>
        <TextHoverButton
          text="Learn more about business vs individual"
          onPress={() =>
            window.open(
              MARKIT_DOCS +
                "/onboarding#businessorganization-vs-individual-account"
            )
          }
          icon={
            <Icon
              icon="tabler:arrow-up-right"
              height={14}
              style={{ color: Colors.GRAY1 }}
            />
          }
          iconPosition="right"
        />
      </div>
    </div>
  );
};

export default PhoneOnboardingSelectType;
